/**
 * Cache store manager.
 */
export default class CacheStore {
	private stores: { [key: string]: Map<string, any> } = {};

	/**
	 * Returns store.
	 *
	 * @param name Name.
	 * @returns Map.
	 */
	public getStore(name: string): Map<string, any> {
		this.stores[name] = this.stores[name] || new Map();
		return this.stores[name];
	}
}
